

export const SIMU_SETTING = 'SIMU_SETTING';

export const updateSimuSetting = simu_setting => {

  return {
    type: SIMU_SETTING,
    payload: simu_setting
  }
}


// export const MAKE_EV_DATA = 'MAKE_EV_DATA';

// export const updateMakeEVData = make_ev_data => {
//   return {
//     type: MAKE_EV_DATA,
//     payload: make_ev_data
//   }
// }


export const MAKE_RANDOM_EV_DATA = 'MAKE_RANDOM_EV_DATA';

export const updateMakeRandomEVData = make_random_ev_data => {
  return {
    type: MAKE_RANDOM_EV_DATA,
    payload: make_random_ev_data
  }
}


export const CHGR_CNT = 'CHGR_CNT';

export const updateChgrCnt = chgr_cnt => {
  return {
    type: CHGR_CNT,
    payload: chgr_cnt
  }
}